import axios from 'axios';

/**
 * True when `error` is one the driver API response interceptor already shaped:
 * a plain Error carrying status 401 or 403. Those keep their status so the UI
 * can tell an expired session from a missing company link.
 *
 * Raw axios errors also carry a `status` field, so a bare status check would
 * let a 400 or 500 through unshaped and the banner would read
 * "Request failed with status code 400" instead of the server's message.
 */
export function isShapedAuthError(error: unknown): boolean {
  if (axios.isAxiosError(error)) return false;
  const status = (error as { status?: unknown } | null | undefined)?.status;
  return status === 401 || status === 403;
}
